import React, { useState, useMemo } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import { useAssessmentContext } from 'js/ydoc/docs/common/AssessmentContext';
import { useAnswerSetContext } from './AnswerSetContext';
// import { faList } from '@fortawesome/pro-regular-svg-icons';
import { useStandardCollator } from 'js/utils/string';
// TODO: make this a combobox
export function AnswerSetSelector({
  questionType,
  currentAnswerSet,
  onChange = () => {},
}) {
  const collator = useStandardCollator();
  const { isValidAnswerSetTypeForQuestion, standardAnswerSets } =
    useAnswerSetContext();
  const [isOpen, setIsOpen] = useState(false);
  const { assessment } = useAssessmentContext();

  const { answerSetList } = useMemo(() => {
    const answerSetMap = {
      ...Object.fromEntries(standardAnswerSets.map((set) => [set.guid, set])),
      ...assessment?.answerSets,
    };

    const answerSetList = Object.values(answerSetMap)
      .filter(
        (x) =>
          x.isPublished && isValidAnswerSetTypeForQuestion(questionType, x.type)
      )
      .sort((a, b) => collator.compare(a.name, b.name));

    return { answerSetMap, answerSetList };
  }, [
    assessment,
    questionType,
    collator,
    isValidAnswerSetTypeForQuestion,
    standardAnswerSets,
  ]);

  return (
    <Dropdown
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
      className="action-selector answer-set-selector"
    >
      <DropdownToggle caret>
        {currentAnswerSet?.isPublished ? (
          <div>{currentAnswerSet.name}</div>
        ) : (
          <div>[Custom]</div>
        )}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onChange(null)}>[Custom]</DropdownItem>
        {answerSetList.map((answerSet) => (
          <DropdownItem
            key={answerSet.guid}
            onClick={() => onChange(answerSet)}
          >
            {answerSet.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default AnswerSetSelector;
